import { computed, inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withState, withProps, withMethods, patchState, withComputed, withHooks } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';
import { AuthService } from '../../services/auth.service.service';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { UserBasicDetailsDto } from '../../Models/UserBasicDetailsDto';
import Keycloak from 'keycloak-js';

export interface MenuState {
    userBaseDetails: UserBasicDetailsDto | null,
  }

const initialMenuState : MenuState = {
  userBaseDetails: null,
};

export const MenuStore = signalStore (
  { providedIn: 'root' },
  withState(initialMenuState),
  withProps(() => ({
    authService: inject(AuthService),
    userService: inject(UserService),
    router: inject(Router),
    keycloak: inject(Keycloak),
  })),
  withComputed(({ userBaseDetails }) => ({
    userName: computed(() => {
      const dat = userBaseDetails()?.firstName as string;
      return dat ?? null;
    }),
  })),
  withMethods(({ authService, userService, router, keycloak, ...store }) => ({
    getUserBaseDetails: rxMethod<void>(
      pipe(
        switchMap(() =>
          userService.getUserBaseDetails().pipe(
            tapResponse({
              next: (baseDetailsResult) => {
                patchState(store, { userBaseDetails: baseDetailsResult.customerDto });
              },
              error: () => {},
            }),
          )),
      ),
    ),
    logout(): void {
      authService.logout();
    },
    returnToDashboard():void {
      router.navigate(['']);
    },
    goToUserDetails():void {
      router.navigate(['/user-details']);
    },
    changePassword():void {
      const resetCredentialsUrl = `${keycloak.authServerUrl}/realms/${keycloak.realm}/login-actions/reset-credentials`;
      window.open(resetCredentialsUrl, '_blank');
    },
  })),
  withHooks({
    onInit(store) {
      if(!store.authService.isNotBinded()) {
        store.getUserBaseDetails();
      }
    },
  }),
);
